import styled from "styled-components";

export const StyledNavbar = styled.div`
    .navbar{
        background-color: white;
        display: flex;
        align-items: center;
        width:100%;
        border-radius: 8px;
        position: relative;
        transition: all 0.4s ease-in-out;
        .back{
            position: fixed;
            width: 100%;
            height: 100vh;
            left:0;
            top: 0;
            background-color: rgba(0,0,0,0.5);
            display: ${({open})=> open ? "block": "none"};
        }
        &.fixed{
            position: fixed;
            top: 0;
            z-index: 20;
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.07);
            left:0;
            padding: 0 250px;
            border-radius:  0;
            @media screen and (max-width: 1600px) {
                    padding: 0 150px;
                }
                @media screen and (max-width: 992px) {
                    padding: 0 50px;
                }
                @media screen and (max-width: 576px) {
                    padding: 0 16px;
                }
        }

        .menu, .front-side{
            display: none;
        }

        .burger{
            width: 100px;
            height: 100px;
            background-color: #F1F1F1;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 8px 0px 0px 8px;
            cursor: pointer;
            &:hover{
                svg{
                    path{
                        fill: #BB0600;
                    }
                }
            }
        }

        .main-logo{
            margin-left: 50px;
            cursor: pointer;
        }

        .nav-list{
            width: calc(100% - 300px);
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 40px;

            .nav-items{
                display: flex;
                align-items: center;
                list-style: none;
                li{
                    margin-right: 50px;
                }
                .nav-item{
                    cursor: pointer;
                    font-weight: 600;
                    font-size: 18px;
                    line-height: 25px;
                    color: #535353;
                    &.active{
                        color: #BB0600;
                    }
                }
                .nav-item:hover{
                    color: #BB0600;
                }
            }

            .login{
               a {
                    background: rgba(187, 6, 0, 0.05);
                    border: 2px solid #BB0600;
                    border-radius: 6px;
                    padding: 10px 40px;
                    font-weight: 600;
                    font-size: 18px;
                    line-height: 25px;
                    color: #BB0600;
                    cursor: pointer;
                    display: inline-block;
                    text-decoration: none;

                    &:hover{
                        background-color: #BB0600;
                        color: white;
                    }
               }
                
            }
        }

       @media (max-width:1440px){
            .burger{
                width: 80px;
                height: 80px;
            }
            .nav-list{
                width: calc(100% - 280px);

                .nav-items{
                    li{
                        margin-right: 20px;
                    }
                }
            }
       }

       @media (max-width: 1200px) {
            .front-side{
                position: fixed;
                background-color:#00000090;
                height: 100%;
                width: 100%;
                left: 0;
                top:0;
                transition: all 0.4s ease-in-out;
                z-index: 25;
                display: ${({ expand }) => expand ? "block" : "none"};
            }
            .nav-list{
                min-width: 300px;
                position: fixed;
                flex-direction: column;
                transition: all 0.4s ease-in-out;
                right: ${({ expand }) => expand ? "0" : "-100%"};
                width: initial;
                height: 100vh;
                top:0;
                z-index: 26;
                padding: 50px 25px;
                background: #10101B;
                justify-content: initial;
                text-align: left;
                align-items: flex-start;
                .nav-items{
                    flex-direction: column;
                    align-items: flex-start;
                    li{
                        margin-right: 0;
                    }
                    .nav-item{
                        font-weight: 600;
                        font-size: 18px;
                        line-height: 25px;
                        color: white;
                        margin-bottom: 15px;
                        display: inline-block
                    }
                }
            }
            .menu{
                position: absolute;
                display: block;
                right:20px;
                z-index: 5;
                cursor: pointer;
                svg{
                    width: 30px;
                    height: 30px;
                    path{
                        fill: ${({ expand }) => expand ? "#10101B" : "initial"}
                    }
                }
            }
       }

       @media (max-width: 576px) {
            .nav-list{
                min-width: 250px;
            }
            .front-side{
                width: 100% 
            }
            .main-logo{
                width: 100px;
                margin-left: 15px;
                img{
                    width: 100%
                }
            }
            .burger{
                width: 50px;
                height: 50px;
                svg{
                    width: 30px;
                }
            }
       }
    }
`